export var TITLE = 'Ollama';
export var TEXT_MULTIPLE = 0.6;
export var SPACE_MULTIPLE = 0.1;
export var COLOR_PRIMARY = '#fff';